import sample_01 from './dynamic-allround-arc.jpg';
import sample_02 from './dynamic-allround-arc-2.jpg';

export const dynamicAllroundArcImpressions = {
    sample_02,
    sample_01,
};
